// extracted by mini-css-extract-plugin
module.exports = {"comp":"Dialog2_comp__Aiec8"};